export default "__VITE_ASSET__TfdVEAS2__"